import { IconButton, Tooltip } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    backgroundColor: 'white',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    color: 'black',
    '&:hover': {
      background: '#bfbfbf',
    },
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.main,
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.black,
    //   },
    // },
  },
}))(MenuItem);

const searchHeaderContaReceberStyles = makeStyles({
  buttonChartContainer: {
    color: 'white',
    backgroundColor: 'rgba(88, 144, 170, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(88, 144, 170, 1)',
      boxShadow: 'none',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(88, 144, 170, 0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(88, 144, 170,0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
  },
});

const ListItemIcon = ({ title, icon, listItem, customStyles }) => {
  const styles = searchHeaderContaReceberStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderListItemText = (item) => {
    return (
      <StyledMenuItem disabled={item.disabled}>
        <ListItemText
          primary={item.title}
          onClick={() => {
            if (item.onClick) {
              item.onClick();
            }
            handleClose();
          }}
        />
      </StyledMenuItem>
    );
  };

  return (
    <>
      <Tooltip title={title}>
        <IconButton className={`${styles.buttonChartContainer} ${customStyles}`} onClick={handleClick}>
          {icon}
        </IconButton>
      </Tooltip>

      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {listItem &&
          listItem
            .filter((item) => !item?.hide)
            .map((item, index) => {
              return item.hint ? (
                <Tooltip key={index} itemRef={index} title={item.hint} placement="left">
                  <div>{renderListItemText(item)}</div>
                </Tooltip>
              ) : (
                renderListItemText(item)
              );
            })}
      </StyledMenu>
    </>
  );
};

export default ListItemIcon;
